import { isJa } from '@/settings/i18n';

export const getFullName = (
  firstName: string,
  lastName: string,
  separator = ' ',
): string => {
  if (isJa()) {
    return [lastName.trim(), firstName.trim()].join(separator);
  }

  return [firstName.trim(), lastName.trim()].join(separator);
};

/**
 * 言語設定に応じて配列の順序を調整します。
 *
 * - 日本語環境（isJa = true）の場合は配列を逆順にします。
 * - それ以外の言語環境では元の順序を保ちます。
 *
 * 主にfirstName, lastNameの表示順の対応するためのユーティリティ関数です。
 *
 * @param elems - 並べ替え対象の配列
 * @returns 並び替え済みの配列（元配列を破壊しない）
 */
export const classifiedSort = <T>(elems: T[]): T[] => {
  return isJa() ? [...elems].reverse() : [...elems];
};
